/* Coming Soon — countdown to the launch date */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(el) {
    const raw = el.dataset.launch;
    if (!raw) return;

    // Accept "YYYY-MM-DDTHH:MM" or full ISO; fall back gracefully.
    const target = new Date(raw).getTime();
    if (isNaN(target)) return;

    const daysEl = el.querySelector('[data-days]');
    const hoursEl = el.querySelector('[data-hours]');
    const minsEl = el.querySelector('[data-minutes]');
    const secsEl = el.querySelector('[data-seconds]');

    function tick() {
      const now = Date.now();
      let diff = Math.max(0, target - now);

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const mins = Math.floor(diff / 60000);
      diff -= mins * 60000;
      const secs = Math.floor(diff / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initPrivacyModal() {
    const modal = document.querySelector('[data-cs-modal]');
    if (!modal) return;

    function open() {
      modal.classList.add('is-open');
      document.body.classList.add('cs-modal-open');
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('cs-modal-open');
    }

    // Intercept clicks on the privacy-policy link inside the consent checkbox.
    document.querySelectorAll('a[href*="privacy-policy"], a[href*="privacidad"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        open();
      });
    });

    modal.querySelectorAll('[data-cs-modal-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-countdown]').forEach(initCountdown);
    initPrivacyModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
